import { Fragment } from 'react';

import { formatTime } from '../../../../utils/utilities';
import { PAUTWeldScanOverview } from '../../../../utils/models';
import { getWeldScanColumns } from '../../../../utils/data';
import { APP_DATE_FORMAT } from '../../../../utils/constants';

import GridItem from '../general/gridItem';
import PDFTablePage from '../../../themed/pdf/pdfTablePage';

interface PAUTWeldScanProps extends PAUTWeldScanOverview {}

const PAUTWeldScan = (props: PAUTWeldScanProps) => {
	return (
		<Fragment>
			<div className="container-fluid overflow-hidden">
				<div className="row">
					<div className="col">
						<GridItem
							title="Shear wave Equipment Sr.No:"
							value={props.shearWaveSrNo}
						/>
						<GridItem
							title="Calibration Certificate Expiry:"
							value={formatTime(props.calibrationExpiryDate, APP_DATE_FORMAT)}
						/>
						<GridItem title="Probe Sr. No:" value={props.probeSrNo} />
						<GridItem title="Probe Frequency:" value={props.probeFrequency} />
						<GridItem title="Weld Condition:" value={props.weldCondition} />
						<GridItem title="Material Type:" value={props.materialType} />
						<GridItem title="Weld Type:" value={props.weldType} />
						<GridItem
							title="Scanning (Internal or External):"
							value={props.scanning}
						/>
						<GridItem title="Couplant Type:" value={props.couplantType} />
					</div>

					<div className="col">
						<GridItem title="Modal Name:" value={props.modalName} />
						<GridItem
							title="Calibration block type:"
							value={props.calibrationBlkType}
						/>
						<GridItem title="Probe Angle:" value={props.probeAngle} />
						<GridItem title="Probe Dia:" value={props.probeDia} />
						<GridItem title="Bevel Angel (A):" value={props.bevelAngle} />
						<GridItem
							title="Weld Thickness (B) :"
							value={props.weldThickness}
						/>
						<GridItem title="Root Gap (C):" value={props.rootGap} />
						<GridItem title="Root Length (D):" value={props.rootLength} />
						<GridItem
							title="Single V or Double V:"
							value={props.singleOrDouble}
						/>
					</div>
				</div>
			</div>

			<PDFTablePage data={props.data ?? []} columns={getWeldScanColumns()} />
		</Fragment>
	);
};

export default PAUTWeldScan;
